import React from 'react'

import './Footer.css'
const Footer = () => {
  return (
    <>
    
    <div className="footer-container">
        
        <a href='https://gajanansr-portfolio.netlify.app/'  
           className='footer-link' 
           target='_blank' 
           rel='noreferrer' >

                     &copy; Designed And Developed By Gajanan Rathod 
         </a>
        

    </div>

    
    </>
  )
}

export default Footer ;